<template>
   <div class="container">
    <top-bar></top-bar>
    <router-view v-slot="{ Component }">
        <keep-alive :include="keepAlivePage">
            <component :is="Component" />
        </keep-alive>
    </router-view>
   </div>
</template>

<script>
import TopBar from "./components/TopBar.vue";

export default {
    name: "App",
    components: {
        TopBar
    },
    data() {
        return {
            keepAlivePage: "HomePage,Api,Course",
        };
    },
};
</script>

<style>
.container{
    display: flex;
    flex-direction: column;
    overflow: auto;
    position: relative;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>
